import * as Yup from "yup";

const NO_LEADING_SPACE_REGEX = /^(?!\s).*/;

export const createDriverDetailsSchema = Yup.object().shape({
  // agentName: Yup.string().required("Agent name is required"),
  agentName: Yup.string()
    .matches(NO_LEADING_SPACE_REGEX, "Agent name cannot start with a space")
    .required("Agent name is required"),
    agentNumber: Yup.string()
    .matches(/^\d+$/, "Agent number must contain only digits")
    .matches(NO_LEADING_SPACE_REGEX, "Number cannot start with a space")
    .max(50, "Agent number cannot exceed 50 digits")
    .required("Agent number is required"),
  
  agentEmail: Yup.string().email("Not a valid email").required("Agent email is required"),
  description: Yup.string().optional().matches(NO_LEADING_SPACE_REGEX, "Description cannot start with a space").max(200, "Description cannot exceed 200 characters"),
  status: Yup.boolean(),
});